const links = [
    {
        id: 1,
        tolink: '/',
        namelink: 'Home 01'
    }
];


export default links ;